import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { pathOr } from 'ramda';
import { Grid } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import { isLight } from 'helpers/colorFunctions';
import { BrandAsset } from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantBrandAssets/MerchantBrandAssets.helpers';
import styles from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantBrandAssets/MerchantBrandAssets.styles';
import ImageId from 'components/ImageId';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  brandAssets: BrandAsset;
};

const DefaultAssets: FunctionComponent<Props> = ({ classes, brandAssets }) => {
  const bundle = pathOr('', ['assets'], brandAssets);
  const primaryColor = pathOr('', ['primaryColor', 'value'], bundle) as string;
  const secondaryColor = pathOr(
    '',
    ['secondaryColor', 'value'],
    bundle,
  ) as string;

  return (
    <Grid className={classes.grid}>
      <Grid.Row>
        <Grid.Column width={8} className={classes.gridColumn}>
          <Grid.Row>
            <div className={classes.fieldGroup}>
              <label className={classes.label}>Card Image:</label>
              <img
                className={classes.card}
                src={pathOr('', ['card', 'path'], bundle) as string}
              />
              <ImageId url={pathOr('', ['card', 'path'], bundle)} />
            </div>
          </Grid.Row>
        </Grid.Column>
        <Grid.Column width={8} className={classes.gridColumn}>
          <Grid.Row>
            <div className={classes.fieldGroup}>
              <label className={classes.label}>Banner Image:</label>
              <img
                className={classes.banner}
                src={pathOr('', ['banner', 'path'], bundle) as string}
              />
              <ImageId url={pathOr('', ['banner', 'path'], bundle)} />
            </div>
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={8} className={classes.gridColumn}>
          <Grid.Row>
            <div className={classes.fieldGroup}>
              <label className={classes.label}>Featured Banner Image:</label>
              <img
                className={classes.banner}
                src={pathOr('', ['featuredBanner', 'path'], bundle) as string}
              />
              <ImageId url={pathOr('', ['featuredBanner', 'path'], bundle)} />
            </div>
          </Grid.Row>
        </Grid.Column>
        <Grid.Column width={8} className={classes.gridColumn}>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Featured Banner Headline:</label>
            <p>
              {
                pathOr(
                  '',
                  ['featuredBannerHeadline', 'value'],
                  bundle,
                ) as string
              }
            </p>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Grid.Row>
            <label className={classes.label}>Brand Colors:</label>
            <div className={classes.brandColors}>
              <Grid.Row className={classes.rowSpacer}>
                <span className={classes.colorLabel}>Primary Color:</span>
                <div className={classes.colorSwatchContainer}>
                  <div
                    className={classes.colorSwatch}
                    style={{ backgroundColor: primaryColor }}
                  >
                    <span
                      style={{ color: isLight(primaryColor) ? '#000' : '#fff' }}
                    >
                      {primaryColor}
                    </span>
                  </div>
                </div>
              </Grid.Row>
              <Grid.Row className={classes.rowSpacer}>
                <span className={classes.colorLabel}>Secondary Color:</span>
                <div className={classes.colorSwatchContainer}>
                  <div
                    className={classes.colorSwatch}
                    style={{ backgroundColor: secondaryColor }}
                  >
                    <span
                      style={{
                        color: isLight(secondaryColor) ? '#000' : '#fff',
                      }}
                    >
                      {secondaryColor}
                    </span>
                  </div>
                </div>
              </Grid.Row>
            </div>
          </Grid.Row>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default withStyles(styles)(DefaultAssets);
